import { Box, Grid } from "@mui/material";
import Wrapper from "../components/layout/Wrapper";
import PropertyDetailsHeader from "../components/PropertyDetails/PropertyDetailsHeader";
import { BoxPaper } from "./PropertyDetails";
import PropertyDetailsCarousel from "../components/PropertyDetails/PropertyDetailsCarousel";
import PropertyDetailsViewing from "../components/PropertyDetails/PropertyDetailsViewing";
import PropertyDetailsMap from "../components/PropertyDetails/PropertyDetailsMap";
import { isMobile } from "react-device-detect";
import { useEffect, useState } from "react";
import ComplexSidebar from "../components/complexes/ComplexSidebar";
import ComplexProperties from "../components/complexes/ComplexProperties";
import { useCollection } from "../hooks/collections/useCollection";
import PropertyDetailsSpecifications from "../components/PropertyDetails/PropertyDetailsSpecifications";
import PropertyDetailsDescription from "../components/PropertyDetails/PropertyDetailsDescription";

type ComplexProps = {
  property: any;
  loadingProperty: boolean;
};

const Complex = ({ property, loadingProperty }: ComplexProps) => {
  const [subProperties, setSubProperties] = useState<any[]>([]);
  const {
    getDataById: getCollectionById,
    data: collectionData,
    loading: loadingCollection,
  } = useCollection();

  const findPropertiesById:any = (root: any, id: number) => {
    // Base case: check if the current root matches the id.
    if (root.id === id) {
      return root.properties || [];
    }
  
    // Recursive case: search through the properties.
    for (const property of root.properties) {
      const z = findPropertiesById(property, id);
      if (z) {
        return z;
      }
    }
  
    // Return null if no match is found.
    return null;
  }

  useEffect(() => {
    if (property) {
      getCollectionById(property.id);
    }
  }, [property]);

  useEffect(() => {
    if (collectionData) {
      const x = findPropertiesById(collectionData, property.id);
      setSubProperties(x);
    }
  }, [collectionData]);

  return (
    <>
      <Wrapper>
        <Box>
          <Grid container spacing={3}>
            <Grid
              gap={2}
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              item
              xs={12}
              lg={12}
            >
              <PropertyDetailsHeader property={property} />
            </Grid>
            <Grid item xs={12} lg={8}>
              <BoxPaper>
                <PropertyDetailsCarousel
                  images={property?.propertyMedia?.propertyImages}
                  loading={loadingCollection}
                />
                <PropertyDetailsDescription property={property} />
              </BoxPaper>
              {isMobile && <PropertyDetailsViewing property={property} />}
              <PropertyDetailsSpecifications property={property} />
              <ComplexProperties properties={subProperties} />
            </Grid>

            <Grid item xs={12} lg={4}>
              <PropertyDetailsMap property={property} />
              <ComplexSidebar property={collectionData} />
              {!isMobile && (
                <PropertyDetailsViewing property={property} />
              )}
            </Grid>
          </Grid>
        </Box>
      </Wrapper>
    </>
  );
};

export default Complex;
